<template>
    <article class="products-article" @click="toPageFamily">
      <img class="products-article-img" :src="products.icon" :alt="products.name" />
      <div class="products-article-carrousel">
        <figure class="products-article-carrousel-slide products-article-carrousel-first-container">
          <div class="img-container">
            <!-- <img @click="toPageFamily" :src="products.foto" :alt="products.name" /> -->
            <img :src="getGif(products.name)" :alt="products.name" />
            <ArrowIcon class="arrow-icon"></ArrowIcon>
          </div>
          <figcaption class="products-article-carrousel-slide-figcaption">
            <div>
              <h3 class="bcLiguria" :style="{color: products.color}">{{ products.name }}</h3>
              <p class="limited-text" v-if="products.text1">{{ products.text1 }}</p>
            </div>
            <!-- <span class="bcLiguria" :style="{color: products.color}">Descargar .PDF</span> -->
          </figcaption>
        </figure>
      </div>
    </article>
</template>

<script>
import ArrowIcon from '@/assets/img/arrow-icon.svg'
export default {
  name: 'ProductLayout',
  props: ['products'],
  components: {
    ArrowIcon
  },
  data () {
    return {
      page: 1.03,
      gifs: {
        'Pieles Arquitectonicas': require('@/assets/img/gif/pieles-arquitectonicas.gif'),
        Quiebravistas: require('@/assets/img/gif/quiebravistas.gif'),
        Cielorrasos: require('@/assets/img/gif/cielorrasos.gif'),
        'Fachadas móviles': require('@/assets/img/gif/fachadas-moviles.gif'),
        'Custom Design': require('@/assets/img/gif/custom-design.gif')
      }
    }
  },
  computed: {
  },
  methods: {
    pageChange (e) {
      // console.log(e)
      if (e === 0) {
        this.page = 1.03
      } else {
        this.page = 2
      }
    },
    getGif (name) {
      return this.gifs[name] || ''
    },
    toPageFamily () {
      // this.$router.push({ path: '/familias/' + this.products.id })
      // ID 36 FAMILIA CUSTOM
      if (this.products.id === '36') {
        window.open('https://mshcustom.com/', '_blank')
      } else {
        this.$router.push({ name: 'family-product', params: { familyProduct: this.products.id + '-' + this.products.path, object: this.products.productos } })
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.products-article{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  cursor: pointer;
  column-gap: calc(var(--main-space) / 2.5);
  &-img{
    width: 40px;
    cursor: pointer;
  }
  &-carrousel{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 40px;
    &-slide{
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: start;
      cursor: pointer;
      gap: 40px;
      height: 500px;
      &:active{
        cursor: move;
      }
      .img-container {
        width: 100%;
        max-width: 50%;
        height: 500px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &-figcaption{
        min-height: 100%;
        width: 50%;
        // width: 480px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // border: 1px solid red;
        h3{
          margin-block-end: calc(var(--main-space) / 2);
          font-size: 26px;
        }
        p{
          width: 90%;
          margin: 0;
          color: #8C9091;
          font-size: 17px;
          line-height: 1.3;
        }
        .limited-text {
          max-height: 400px; /* Altura máxima */
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 18; /* Número máximo de líneas */
          -webkit-box-orient: vertical;
        }
        span{
          margin-right: auto;
          background: black;
          padding: 0.5rem 1rem;
        }
      }
      .arrow-icon{
        display: none;
        position: absolute;
        width: 55px;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        fill: #ffffff;
        mix-blend-mode: difference;
      }
    }
  }
}

// .products-article-carrousel-first-container {

//   figcaption {
//     width: 50%;
//   }
// }
.products-article-carrousel-family img {
  width: calc(100% - 40px);
  max-width: 800px;
}

@include media-breakpoint-down(md) {
  .products-article{
    flex-direction: column;
    row-gap: calc(var(--main-space) / 2.5);
    position: relative;
    .products-article-img{
      position: absolute;
      top: 250px;
      z-index: 2;
      left: 10px;
    }
  }
  .products-article-carrousel-slide{
    flex-direction: column;
    height: auto;
    img, figcaption{
      width: 100%;
      max-width: 100%;
    }
    .img-container{
      height: 300px;
      max-width: 100%;
    }
  }
  .products-article-carrousel-slide-figcaption p{
    width: 100%;
  }
}@include media-breakpoint-down(sm) {
  .products-article{
    &-carrousel{
      &-slide{
        &-figcaption{
          h3{
            margin-block-end: var(--main-space);
          }
        }
        .arrow-icon{
          display: inherit;
        }
      }
    }
  }
}
</style>
